import { render } from "./ViewChoose.vue?vue&type=template&id=3e7d2f87"
import script from "./ViewChoose.vue?vue&type=script&lang=ts"
export * from "./ViewChoose.vue?vue&type=script&lang=ts"
script.render = render

export default script